module.exports = __webpack_public_path__ + "static/media/tax-service-img.35fca89a.png";